<template>
  <path
    d="M2 12.0002C2 6.48018 6.48 2.00018 12 2.00018C17.52 2.00018 22 6.48018 22 12.0002C22 17.5202 17.52 22.0002 12 22.0002C6.48 22.0002 2 17.5202 2 12.0002ZM12 18.0002C15.31 18.0002 18 15.3102 18 12.0002C18 8.69018 15.31 6.00018 12 6.00018C8.69 6.00018 6 8.69018 6 12.0002C6 15.3102 8.69 18.0002 12 18.0002Z"
  />
</template>
